<ub-heading i18n>Audit log</ub-heading>

<button mat-flat-button
        color="secondary"
        type="button"
        (click)="show = !show">{{ getButtonAction() }}</button>

<ng-container *ngIf="show">
  <mat-list *ngIf="logs.length > 0; else noActivityTemplate">
    <mat-list-item *ngFor="let log of logs">
      <span mat-line>{{ log.date | date:'medium' }}</span>
      <span mat-line *ngIf="!log.masquerade">
        <eas-user-title username="{{ log.actor }}"></eas-user-title> {{ mapping[log.action] ?? log.action }}
      </span>
      <span mat-line *ngIf="log.masquerade">
        <eas-user-title username="{{ log.masquerade }}"></eas-user-title> <ng-container i18n>as</ng-container>
        <eas-user-title username="{{ log.actor }}"></eas-user-title> {{ mapping[log.action] ?? log.action }}
      </span>
      <span mat-line *ngIf="log.source">
        <ng-container i18n>source: </ng-container> {{ log.source }}
      </span>
    </mat-list-item>
  </mat-list>
  <ng-template #noActivityTemplate>
    <p i18n>There has been no activity...</p>
  </ng-template>
</ng-container>
